<template lang="pug">
  .mRow
    .mRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.no-gutters.flex-nowrap.align-items-start
          .mRow__profileImg.mr-3
          .d-flex.align-items-end.flex-nowrap.no-gutters
            .mRow__content.mRow__textBox.position-relative.d-flex.align-items-center
              .textBox__insideTextBox
                a(v-if="this.messageData.text.includes('https://')" :href="this.messageData.text" target="_blank") {{ this.messageData.text }}
                span(
                  v-else
                  v-html="filterText(this.messageData.text)"
                )
            .mRow__timeBox
              span(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'M-Text',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
